module.exports = __webpack_public_path__ + "static/media/down.35c8297d.svg";